import { MainHeading } from '@/components/common/MainHeading'
import { Layout } from '@/components/Layout/Layout'
import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import StoreProfile from './StoreProfile'
import StoreControls from './StoreControls'
import SecurityTab from './SecurityTab'
import AdminSettings from './AdminSettings'
import CheckoutMessage from './CheckoutMessage'
import StoreBankDetails from './StoreBankDetails'
import StoreWallet from './StoreWallet'
import { useActiveRole } from '@/hooks/useActiveRole'
import { usePermissions } from '@/hooks/usePermissions'
import { RESOURCES } from '@/context/permissions'

export const SettingsPage = () => {
    const { canAdminSettings, canStoreSettings, isAdmin } = usePermissions();
    const [searchParams, setSearchParams] = useSearchParams();
    const defaultTab = isAdmin ? 'admin' : 'profile';
    const activeTab = searchParams.get('tab') || defaultTab;

    const setActiveTab = (tab: string) => setSearchParams({ tab });

    return (
        <Layout>
            <MainHeading title="Settings" />

            <div className="mt-6">
                <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
                    <TabsList className="">
                        {canAdminSettings(RESOURCES.SETTINGS) && <TabsTrigger value="admin">Admin Settings</TabsTrigger>}
                        {canStoreSettings(RESOURCES.SETTINGS) && !isAdmin && (
                            <>
                                <TabsTrigger value="profile">Store Profile</TabsTrigger>
                                {/* <TabsTrigger value="wallet">Wallet</TabsTrigger> */}
                                <TabsTrigger value="bank-details">Bank Details</TabsTrigger>
                                {/* <TabsTrigger value="controls">Store Controls</TabsTrigger> */}
                                <TabsTrigger value="checkout-message">Store Holiday</TabsTrigger>
                            </>
                        )}
                        <TabsTrigger value="security">Security</TabsTrigger>
                    </TabsList>

                    {canAdminSettings(RESOURCES.SETTINGS) && (
                        <TabsContent value="admin" className="mt-6">
                            <AdminSettings />
                        </TabsContent>
                    )}

                    {canStoreSettings(RESOURCES.SETTINGS) && !isAdmin && (
                        <>
                            <TabsContent value="profile" className="mt-6">
                                <StoreProfile />
                            </TabsContent>

                            {/* <TabsContent value="wallet" className="mt-6">
                                <StoreWallet />
                            </TabsContent> */}

                            <TabsContent value="bank-details" className="mt-6">
                                <StoreBankDetails />
                            </TabsContent>

                            {/* <TabsContent value="controls" className="mt-6">
                                <StoreControls />
                            </TabsContent> */}

                            <TabsContent value="checkout-message" className="mt-6">
                                <CheckoutMessage />
                            </TabsContent>
                        </>
                    )}

                    <TabsContent value="security" className="mt-6">
                        <SecurityTab />
                    </TabsContent>
                </Tabs>
            </div>
        </Layout>
    )
}

